import { useApiClient } from "@/lib/api/api.client";
import type { components } from "@soulbyte/core";

export type UploadRestrictions = components["schemas"]["UploadRestrictionsDTO"];
export type FileCategoryRestriction = components["schemas"]["FileCategoryDTO"];

// server config that changes rarely; avoid refetching every time an upload dialog opens
const STALE_TIME_MS = 30 * 60 * 1000;

/**
 * useUploadRestrictions reads the backend's live upload limits: per-type size,
 * extension and mime caps, and per-assistant document/asset quotas. It is
 * fetched once on login (see UploadRestrictionsWarmup) and every upload
 * surface in the app reads from this cached query instead of hardcoding its
 * own limits.
 */
export function useUploadRestrictions() {
  const apiClient = useApiClient();
  return apiClient.useQuery(
    "get",
    "/uploads/restrictions",
    {},
    { staleTime: STALE_TIME_MS },
  );
}
